import http from "../httpService";
import {
  GetAutoCompleteRoot,
  GetAutoCompleteKeyword,
} from "../../types/GetAutocomplete.types";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { useAppSelector } from "../../store/hooks";
import { temporaryQueryConstructor } from "../../screens/AdvancedSearch/TemporaryQueryConstructor";
import { useRef } from "react";
import api from "../endpoints";

interface SpellCorrectionResponse {
  corrected_text: string;
  suggestions: {
    buckets: string[];
  };
  message: string;
}

const cunstomerId = sessionStorage.getItem("informaticscustomer_id");
console.log("cunstomerId", cunstomerId);

export const useGetAutoComplete = (
  query: string,
  isMesh: boolean = false,
  subs_key: boolean = false,
  enabled: boolean = true,
) => {
  const l1SubjectIds = useAppSelector(
    (state) => state.searchReducer.subjectL1Type,
  );
  const uniqueIds = [...new Set(l1SubjectIds || [])];
  const encodedSubjectIds = temporaryQueryConstructor(uniqueIds);

  const abortControllerRef = useRef<AbortController | null>(null);

  if (abortControllerRef?.current) {
    abortControllerRef.current.abort();
  }

  const abortController = new AbortController();
  abortControllerRef.current = abortController;

  // return useQuery(
  //   ["GetAutoComplete", query,isMesh],
  //   () =>
  //     http.get(
  //       // "/api/indexingGen/solrGeneral/autofillcore?page=1&rows=1&facet_limit=25&facet_fields=keyword&datsubjectmasterlevel1_ids=(5)",
  //       `/api/indexingGen/solrGeneral/autofillcore?page=1&rows=1&facet_limit=25&facet_fields=keyword${
  //       isMesh ? "&fq__mesh_key=true" : subs_key ? "&fq__subs_key=true" : ""
  //     }&datsubjectmasterlevel1_ids=(${encodedSubjectIds})`,
  //       {
  //         params: {
  //           facet_prefix: query,
  //         },
  //         signal: abortController.signal,
  //       }
  //     ),
  //   {
  //     select: (
  //       res: AxiosResponse<GetAutoCompleteRoot>
  //     ): GetAutoCompleteKeyword[] => {
  //       return res.data.data.facets.facet_fields.keyword;
  //     },
  //     enabled: query.length > 2, //Wont work for <2 chars
  //   }
  // );

  // return useQuery(
  //   ["GetAutoComplete", query, isMesh],
  //   async () => {
  //     // cancel any previous request
  //     if (abortControllerRef.current) {
  //       abortControllerRef.current.abort();
  //     }

  //     // create a new abort controller for this request
  //     const abortController = new AbortController();
  //     abortControllerRef.current = abortController;

  //     // make the request
  //     const res = await http.get(
  //       `/api/indexingGen/solrGeneral/autofillcore?page=1&rows=1&facet_limit=25&facet_fields=keyword${
  //         isMesh ? "&fq__mesh_key=true" : subs_key ? "&fq__subs_key=true" : ""
  //       }&datsubjectmasterlevel1_ids=(${encodedSubjectIds})`,
  //       {
  //         params: {
  //           facet_prefix: query,
  //         },
  //         signal: abortController.signal,
  //       }
  //     );

  //     return res;
  //   },
  //   {
  //     select: (
  //       res: AxiosResponse<GetAutoCompleteRoot>
  //     ): GetAutoCompleteKeyword[] => {
  //       return res.data.data.facets.facet_fields.keyword;
  //     },
  //     enabled: query.length > 2, // Won’t run for <3 chars
  //   }
  // );

  return useQuery(
    ["GetAutoComplete", query, isMesh],
    ({ signal }) =>
      http.get(
        `/api/indexingGen/solrGeneral/autofillcore?page=1&rows=1&facet_limit=25&facet_fields=keyword${
          isMesh ? "&fq__mesh_key=true" : subs_key ? "&fq__subs_key=true" : ""
        }&datsubjectmasterlevel1_ids=(${encodedSubjectIds})`,
        {
          params: { facet_prefix: query },
          signal, // provided by React Query
        },
      ),
    {
      select: (
        res: AxiosResponse<GetAutoCompleteRoot>,
      ): GetAutoCompleteKeyword[] => res.data.data.facets.facet_fields.keyword,
      enabled: query.length > 2 && enabled,
    },
  );
};

// ---------------------- Spell Correction Hook ----------------------
export const useSpellCorrection = (query: string, enabled: boolean = true) => {
  const spellCorrectionQuery = useQuery(
    ["SpellCorrection", query],
    async () => {
      const res = await http.get<SpellCorrectionResponse>(
        `/api/SpellCorrectionAPI/SpellCorrectionAPI`,
        { params: { text: query } },
      );
      return res.data;
    },
    {
      enabled: !!query && query.length > 2 && enabled,
    },
  );

  const wrongWord =
    spellCorrectionQuery.data &&
    spellCorrectionQuery?.data?.corrected_text.toLowerCase() !==
      query.toLowerCase()
      ? query
      : null;
  const suggestionsData = spellCorrectionQuery?.data || [];

  return { spellCorrectionQuery, wrongWord, suggestionsData };
};
